import React, { useEffect, useState } from 'react'
import { Card, Accordion, Button } from 'react-bootstrap';
import { useParams, useRouteMatch, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Truncate from "react-truncate";
import Tooltip from "components/Tooltip";

import _ from 'lodash';
import cx from 'classnames';
import dateformat from "dateformat";

import { createHubspotForm, updateHubspotForm } from 'actions/forms/hubspot';
import { fetchForm, toggleFormManageView } from 'actions/forms/forms';
import { fetchHubspotForms, selectHubspotForm } from 'actions/integrations/hubspot';
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';

import { getBaseUrl } from 'services/util';
import CustomToggle from '../../components/customToggle';
import FormPreview from '../../components/formPreview';
import InfiniteScroll from "components/InfiniteScroll";

import styles from '../../forms.module.scss';

export default function HubspotFormConfigurations(props) {
  const dispatch = useDispatch();

  const history = useHistory();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const selectedForm = useSelector(state => _.get(state, "integrations.hubspot.forms.selectedForm", null));
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", null));
  const page = useSelector(state => _.get(state, "integrations.hubspot.forms.page", 0));
  const limit = useSelector(state => _.get(state, "integrations.hubspot.forms.limit", 20));

  const [state, setState] = useState({
    formPreview: false,
    activatedKey: "1",
    testCompleted: false
  })

  useEffect(() => {
    dispatch(toggleFormManageView(true))
    dispatch(fetchHubspotForms(page, limit));

    return () => {
      dispatch(toggleFormManageView(false))
    };
  }, [])

  const handleSaveClick = () => {
    setState(state => {
      return {
        ...state,
        testCompleted: false,
        activatedKey: "2"
      }
    })

    if (selectedForm && !currentForm) {
      var createFormRequest = {
        name: selectedForm.name,
        guid: selectedForm.guid,
        type: "hubspot"
      }

      dispatch(createHubspotForm(createFormRequest))
    }

    if (selectedForm && currentForm && (selectedForm.guid != currentForm.configuration.guid)) {

      var updateRequest = {
        id: currentForm.id,
        guid: selectedForm.guid
      }

      dispatch(updateHubspotForm(updateRequest))
    }
  }

  const handleTestClick = () => {
    setState(state => {
      return {
        ...state,
        formPreview: true
      }
    })
  }

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        activatedKey: "3",
        formPreview: false,
        testCompleted: false
      }
    })
  }

  const handleCustomToggle = (key) => {
    setState(state => {
      return {
        ...state,
        activatedKey: key,
        testCompleted: false
      }
    })
  }

  const handleFormSubmit = () => {
    setState(state => {
      return {
        ...state,
        formPreview: false,
        testCompleted: true,
        activatedKey: "3"
      }
    })
  }

  const handleDoneContainer = () => {
    var url = `${baseUrl}/integration-settings/forms`;
    history.push(url);
  }

  return (
    <div className={styles.formConfigurationContainer}>
      <Accordion className={styles.accordion} defaultActiveKey={state.activatedKey}>
        <Card>
          <Card.Header className={cx(styles.table, { [styles.completed]: state.activatedKey != "1" })}>
            <div className={styles.title} >
              <div className={styles.icon}>
                {state.activatedKey != "1" ? <i className="cleverstory-tick"></i> : "1"}
              </div>
              <div className={styles.name}>Select a Hubspot Form</div>
              {selectedForm &&
                <>
                  <div className={styles.divider}></div>
                  <div className={styles.selectedForm}>
                    <div className={styles.title}>Selected form: </div>
                    <div className={styles.formName}>
                      <TruncatedTextWithTooltip content={selectedForm.name} maxWidth="200" placement="top" />
                    </div>
                  </div>
                </>}
            </div>
            {parseInt(state.activatedKey) > 1 && <CustomToggle eventKey="1" onClick={() => handleCustomToggle("1")}>Choose a different form</CustomToggle>}
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <HubspotForms onFormSubmit={() => handleFormSubmit()} />
              <div className={cx(styles.bottom, styles.doneButtonContainer, styles.border_top, styles.pt_30)}>
                <CustomToggle eventKey="1" onClick={() => handleSaveClick()} isComplete={true} disabled={!selectedForm}>Save & Continue</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Card.Header className={cx({ [styles.disabled]: parseInt(state.activatedKey) < 2 }, { [styles.completed]: parseInt(state.activatedKey) > 2 })}>
            <div className={styles.title}>
              <div className={styles.icon}>
                {parseInt(state.activatedKey) > 2 ? <i className="cleverstory-tick"></i> : "2"}
              </div>
              <div className={styles.name}>Test the code</div>
            </div>
            {state.testCompleted && <div className={styles.success}>Test Successfull</div>}
            {!state.testCompleted && <CustomToggle eventKey="2">Test the form</CustomToggle>}
          </Card.Header>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <TestTheCode />
              <div className={cx(styles.bottom, styles.doneButtonContainer, styles.table)}>
                <CustomToggle eventKey="2" onClick={() => handleTestClick()} isComplete={true}>Test the Code</CustomToggle>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      {state.formPreview &&
        <FormPreview preview={state.formPreview} editable={true} form={selectedForm} onClose={handleClose} />
      }

      {parseInt(state.activatedKey) > 1 &&
        <div className={styles.finishButton}>
          <Button className={styles.actionButton}
            onClick={handleDoneContainer}
            size="sm"
            variant="primary"
          >
            Done
          </Button>
        </div>
      }
    </div>
  );
}

function HubspotForms(props) {
  const dispatch = useDispatch();
  const page = useSelector(state => _.get(state, "integrations.hubspot.forms.page", 0));
  const limit = useSelector(state => _.get(state, "integrations.hubspot.forms.limit", 20));
  const loading = useSelector(state => _.get(state, "integrations.hubspot.forms.loading", false));
  const loadMoreResults = useSelector(state => _.get(state, "integrations.hubspot.forms.loadMore", 0));
  const currentForm = useSelector(state => _.get(state, "forms.currentForm", null));
  const selectedForm = useSelector(state => _.get(state, "integrations.hubspot.forms.selectedForm", null));

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type == 'hubspot';
  });

  const forms = useSelector(state => _.get(state, "integrations.hubspot.forms.items", []));
  const headers = ["Name", "Created on", "Updated on"]
  const [selectedFormId, setSelectedFormId] = useState(null);

  const { formId } = useParams();
  const region = _.get(integration, 'configuration.region', null);
  const portalId = _.get(integration, 'configuration.portalId', null);

  const loadMore = () => {
    if (loading) {
      return;
    }

    dispatch(fetchHubspotForms(page, limit));
  }

  useEffect(() => {
    window.addEventListener("message", function (event) {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        props.onFormSubmit()
      }
    });
  }, [])

  const renderHubpotForm = (formId) => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        region: region || "na1",
        portalId: portalId,
        formId: formId,
        target: "#contact_form"
      });
    }
  }

  useEffect(() => {
    if (formId && formId != "new") {
      dispatch(fetchForm(formId))
      return;
    }
  }, [formId])

  useEffect(() => {
    if (currentForm) {
      var guid = _.get(currentForm, 'configuration.guid', null);
      setSelectedFormId(guid)
      dispatch(selectHubspotForm(currentForm))
    }
  }, [currentForm])

  useEffect(() => {
    if (selectedFormId && integration) {
      renderHubpotForm(selectedFormId)
    }
  }, [selectedFormId, integration]);

  const handleSelectForm = (form) => {
    setSelectedFormId(form.guid);
    dispatch(selectHubspotForm(form))
  }

  return (
    <div className={styles.externalFormContainer}>
      <div className={styles.left}>
        <div className={styles.formData}>
          <div className={cx(styles.row, styles.no_border)}>
            <div className={cx(styles.container, styles.no_border)}>
              {headers.map(header => {
                return (
                  <div className={styles.column}>{header}</div>
                )
              })}
            </div>
          </div>
          {loading && forms.length == 0 && <div className={styles.loadingMessage}>Loading Forms ...</div>}

          {forms.length > 0 && <InfiniteScroll
            className={cx(styles.scrollable)}
            loading={loading}
            hasMore={loadMoreResults}
            loadMore={() => { loadMore() }}>

            {forms.map(form => {
              var isActive = form && form.guid === selectedFormId;
              return (
                <FormData form={form} isActive={isActive} handleSelectForm={handleSelectForm}
                selectedFormId={selectedFormId} />
              )
            })}

          </InfiniteScroll>}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.contactForm} id="contact_form">
          {!currentForm && !selectedForm && <div>Select any form to display !</div>}
        </div>
      </div>
    </div>
  )
}

function FormData({form, isActive, handleSelectForm, selectedFormId}) {

  const [tooltip, setTooltip] = useState(false);

  const handleTooltip = (truncated) => {
    setTooltip(truncated);
  }

  return (
    <div  className={cx(styles.row, { [styles.active]: isActive })}>
      <div className={styles.container} onClick={() => handleSelectForm(form)}>
        <div className={cx(styles.radioButton, styles.column)}>
          <input type="radio" checked={selectedFormId === form.guid}></input>
          <label className={cx(styles.formName)}>
            <Tooltip placement="top" content={form.name} disabled={!tooltip}>
              <Truncate ellipsis={( <span>...</span>)} onTruncate={handleTooltip} width={200} lines={1}>
                {form.name}
              </Truncate>
            </Tooltip>
          </label>
        </div>
        <div className={cx(styles.data, styles.column)}>{dateformat(_.get(form, 'createdAt'), 'dd mmm yyyy')}</div>
        <div className={cx(styles.data, styles.column)}>{dateformat(_.get(form, 'internalUpdatedAt'), 'dd mmm yyyy')}</div>
      </div>
   </div>
  )
}

function TestTheCode() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.testTheCode}>
        <div className={styles.tcContent}>
          Just to make sure everything’s working the way it has to, please test the form by entering sample data. If the test is successful, the sample entry should be recorded in your database. Incase the test is unsuccessful, please recheck the connection with the third party application where you’re importing the form from.         </div>
      </div>
    </div>
  )
}